import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Modal from "../../../Pages/ModalForm";
import "../../BusinessTravel/BTmidBanner/BTmidBanner.css";

import "../../Restrictions/RestrictionLastBanner/RestrictionLastBanner.css";
import "./SportsMidBanner.css";
import Heading from "../../../utls/Heading";
const SportsMidBanner = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = (e) => {
    e.preventDefault(); // Prevent any default anchor behavior
    setShowModal(true); // Show the modal
  };

  const handleClose = () => setShowModal(false); // Close the modal

  return (
    <>
      <div className="container sports-mid-section">
        <div className="row px-md-4">
          <div className="col-md-12">
            <Heading className="customheadings">
              <span>Global Sports </span>Event Travel Solutions
            </Heading>
            <p className="grotesk-headings sports-mid-banner-p">
              Our specialized travel team provides exclusive access to major
              sports events across the globe. From the exciting World Cup to the
              magnificence of the Olympics and the excitement of the Super Bowl,
              we cover it all. With over 100,000 satisfied sports travelers and
              partnerships with leading event organizers, our sports travel
              services ensure you experience every thrilling moment in style.
            </p>
          </div>
        </div>
      </div>
      <div className="last-banner bt-last-banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 text-white">
              <Heading className="headings sports-banner-head">
                <span className="last-banner-span">Ready to</span> Experience
                World-Class Sports Travel{" "}
                <span className="text-white" style={{ fontWeight: "bold" }}>
                  ?{" "}
                </span>
              </Heading>
              {/* <p>Contact Blueberry Travel Today</p> */}
              <div className="carouselCaption">
                <button
                  className="btn bg-transparent text-white mt-md-3 grotesk-headings fw-bold"
                  type="button" // Use type="button" to prevent form submission
                  onClick={handleShow}
                >
                  REQUEST DEMO
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <div className=" bt-last-banner sports-mid-banner-img">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/sportsgir;.png"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Conditionally render the Modal */}
      <Modal show={showModal} handleClose={handleClose} />
    </>
  );
};

export default SportsMidBanner;
